// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b9815919","977":"3fd645a6"}[chunkId] + ".chunk.js";
};